import { Box } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import FormWrapper from 'modules/contracts/components/FlowPage/FormWrapper'
import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import { translate } from 'modules/contracts/lib/translate'
import { ContractFieldsProps } from 'modules/contracts/lib/types'

interface Props {
  form: Form
  translations: { [key: string]: string }
  canSeeWorkingDayType: boolean
}

function getOptions(values: ContractFieldsProps[]) {
  return values
    .filter((value) => value.archivedAt === null)
    .map((value) => ({
      value: value.id,
      label: value.name,
    }))
}

const FranceLegalAndExtras = ({ form, translations, canSeeWorkingDayType }: Props) => {
  const { frenchContractData } = useLegalEntityContractData()

  return (
    <FormWrapper>
      <Box gap="s24">
        {canSeeWorkingDayType && (
          <Select
            field={form.get('fr_work_type_id')}
            label={translate(translations, 'work_type')}
            options={getOptions(frenchContractData.workTypes)}
            none={i18n.t('common.none')}
          />
        )}
        <Select
          field={form.get('fr_employee_type')}
          label={translate(translations, 'employee_type')}
          options={frenchContractData.employeeTypes}
          none={i18n.t('common.none')}
        />
        <Select
          field={form.get('fr_step_id')}
          label={translate(translations, 'step')}
          options={getOptions(frenchContractData.steps)}
          none={i18n.t('common.none')}
        />
        <Select
          field={form.get('fr_level_id')}
          label={translate(translations, 'level')}
          options={getOptions(frenchContractData.levels)}
          showOriginalLabelText
          none={i18n.t('common.none')}
        />
        <Select
          field={form.get('fr_mutual_id')}
          label={translate(translations, 'mutual')}
          options={getOptions(frenchContractData.mutuals)}
          none={i18n.t('common.none')}
        />
        <Select
          field={form.get('fr_professional_category_id')}
          label={translate(translations, 'professional_category')}
          options={getOptions(frenchContractData.professionalCategories)}
          showOriginalLabelText
          none={i18n.t('common.none')}
        />
      </Box>
    </FormWrapper>
  )
}

export default observer(FranceLegalAndExtras)
